import URL from "../helpers/URL";

$(document).ready(function () {
    $('.link-menu').click(function (e) {
        e.preventDefault();
        var target = $($(this).attr('href'));

        $('html, body').animate({
            scrollTop: target.offset().top
        }, 550)
    });

    if (URL.hash) {
        var offsetHeight = $('.header').innerHeight();
        $('html, body').animate({
            scrollTop: $(URL.hash).offset().top - offsetHeight
        }, 500);
    }
});